
import React from "react";
import {getBrand} from "../lib/functions"

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand : null,
      width: 0
    }
  }

  
  componentDidMount = () =>  {
    this.setState({brand : getBrand(), width: window.innerWidth});
    window.addEventListener('resize', this.updateDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  
  updateDimensions = () => {
    this.setState({ width: window.innerWidth});
  };

  render() {
    return (          
            <div className="Header">
              {this.state.brand ? 
                <React.Fragment>
                    {this.props.student ? 
                  <React.Fragment>
                    <div className="header-logo post-login">{this.state.width > 1200 ? <img alt={this.state.brand.title} src={this.state.brand.logo}/> : <img alt={this.state.brand.title} src={this.state.brand.mobileLogo}/>}</div>
                    <h1 className="header-title post-login">Student Portal</h1>
                      <div className="header-btn-container">
                        <span className="user-title header-user"><i className="header-menu-icon" />{this.props.student.fullname}</span>
                        <a className="user-title header-options" href="https://stsupport.exampro.co.uk/kb/" target="_blank" rel="noreferrer"><i className="header-menu-icon fa fa-question" /><span className="header-text">Help</span></a>
                        <a className="user-title header-options" href="/logout.php"><i className="header-menu-icon fa fa-power-off" /><span className="header-text">Log out</span></a>
                      </div>
                  </React.Fragment> 
                    :
                  <React.Fragment>
                    <div className="header-logo"><img alt={this.state.brand.title} src={this.state.brand.logo}/></div>
                      <h1 className="header-title pre-login">Student Portal</h1> 
                      <div className="header-btn-container pre-login">
                        <a className="user-title header-options" href="https://stsupport.exampro.co.uk/kb/" target="_blank" rel="noreferrer"><i className="header-menu-icon fa fa-question" /><span className="header-text">Help</span></a>
                      </div>
                    </React.Fragment>
                    }
                </React.Fragment>
              : null}
            </div>
           )
   }
}
